import React, { useState } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const TurbineDetailsModal = ({ isOpen, onClose, turbine, onEdit, onSaveInstructions }) => {
  const [selectedInstructions, setSelectedInstructions] = useState([]);
  console.log("Dane przekazane do TurbineDetailsModal:", turbine);

  if (!isOpen || !turbine) return null;

  const handleInstructionSelect = (instructionId) => {
    setSelectedInstructions((prevSelected) =>
      prevSelected.includes(instructionId)
        ? prevSelected.filter((id) => id !== instructionId) // Usuń jeśli już jest wybrana
        : [...prevSelected, instructionId] // Dodaj jeśli nie jest wybrana
    );
  };

  const handleSave = () => {
    if (selectedInstructions.length === 0) {
      alert("Please select at least one instruction before saving.");
      return; // Przerwij funkcję, jeśli nic nie jest zaznaczone
    }
  
    const insToSave = turbine.instructions.filter((instr) =>
      selectedInstructions.includes(instr.id)
    );
    onSaveInstructions(insToSave); // Wywołanie funkcji z danymi
  };

  const handleDelete = async () => {
    if (window.confirm("Czy na pewno chcesz usunąć tę turbinę?")) {
      try {
        const response = await fetch(`${API_BASE_URL}/turbines/${turbine.id}/`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Błąd podczas usuwania turbiny.");
        }

        console.log(`Turbina ${turbine.id} została usunięta.`);        
        onClose(); // Zamknij modal po usunięciu
      } catch (err) {
        console.error(err.message);
        alert("Wystąpił błąd podczas usuwania turbiny. Spróbuj ponownie.");
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex justify-center items-center z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-6xl relative overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-brand-50 to-white px-6 py-4 border-b border-brand-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-brand-100 rounded-xl flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-brand-600">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 2v4"/>
                <path d="m6.34 6.34 2.83 2.83"/>
                <path d="M2 12h4"/>
                <path d="m6.34 17.66 2.83-2.83"/>
              </svg>
            </div>
            <div>
              <h2 className="text-xl font-bold text-graphite-900">Turbine Details</h2>
              <p className="text-sm text-graphite-500">{turbine.name} - {turbine.number}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-graphite-500 hover:bg-steel-100 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18"/>
              <path d="m6 6 12 12"/>
            </svg>
          </button>
        </div>

        <div className="p-6 grid grid-cols-3 gap-6">
          {/* Kolumna 1: Szczegóły turbiny */}
          <div className="col-span-1">
            <div className="bg-steel-50 rounded-xl p-4 space-y-3">
              <h3 className="text-sm font-semibold text-graphite-700 uppercase tracking-wide mb-3">Specifications</h3>
              <div className="space-y-2">
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Number</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.number}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Name</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.name}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Manufacturer</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.manufacturer}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Model</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.model}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Type</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.type}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Location</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.location}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Wind Farm</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.windFarm}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-steel-200">
                  <span className="text-sm text-graphite-500">Power</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.power}</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm text-graphite-500">Height</span>
                  <span className="text-sm font-medium text-graphite-900">{turbine.height}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Kolumna 2: Instrukcje */}
          <div className="col-span-2">
            <div className="bg-gradient-to-r from-blue-50 to-white rounded-xl border border-blue-100 overflow-hidden">
              <div className="px-4 py-3 border-b border-blue-100 flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-600">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                    <path d="M10 9H8"/>
                    <path d="M16 13H8"/>
                    <path d="M16 17H8"/>
                  </svg>
                </div>
                <h3 className="text-base font-semibold text-graphite-900">Instructions</h3>
                {turbine.instructions && turbine.instructions.length > 0 && (
                  <span className="ml-auto text-sm text-graphite-500">{turbine.instructions.length} instruction(s)</span>
                )}
              </div>
              {turbine.instructions && turbine.instructions.length > 0 ? (
                <div
                  className="overflow-y-auto bg-white"
                  style={{ maxHeight: "24rem" }}
                >
                  <table className="min-w-full">
                    <thead className="bg-steel-50 sticky top-0">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">
                          Work Scope
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">
                          Created By
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">
                          Created Time
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-semibold text-graphite-700 uppercase tracking-wider">
                          Version
                        </th>
                        <th className="px-4 py-3 text-center">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedInstructions(turbine.instructions.map((instr) => instr.id));
                              } else {
                                setSelectedInstructions([]);
                              }
                            }}
                            checked={
                              selectedInstructions.length === turbine.instructions.length &&
                              turbine.instructions.length > 0
                            }
                            className="h-4 w-4 text-brand-500 border-steel-300 rounded focus:ring-brand-500"
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-steel-100">
                      {turbine.instructions.map((instr, idx) => (
                        <tr key={idx} className={`transition-colors ${selectedInstructions.includes(instr.id) ? 'bg-brand-50' : 'hover:bg-steel-50'}`}>
                          <td className="px-4 py-3 text-sm text-graphite-900 font-medium">
                            {instr.scope_of_work_data.name || "Bez tytułu"}
                          </td>
                          <td className="px-4 py-3 text-sm text-graphite-600">
                            {instr.created_by_data || "Nieznane"}
                          </td>
                          <td className="px-4 py-3 text-sm text-graphite-600">
                            {instr.created_time
                              ? new Date(instr.created_time).toLocaleString("pl-PL", {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "Nieznane"}
                          </td>
                          <td className="px-4 py-3 text-sm text-graphite-600">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-steel-100 text-graphite-700">
                              {instr.version || "N/A"}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center">
                            <input
                              type="checkbox"
                              checked={selectedInstructions.includes(instr.id)}
                              onChange={() => handleInstructionSelect(instr.id)}
                              className="h-4 w-4 text-brand-500 border-steel-300 rounded focus:ring-brand-500"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="p-8 text-center bg-white">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-steel-300 mx-auto mb-3">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                  </svg>
                  <p className="text-graphite-500">No instructions for this turbine.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Przyciski na dole */}
        <div className="px-6 py-4 border-t border-steel-200 bg-steel-50 flex items-center justify-between">
          <div className="text-sm text-graphite-500">
            {selectedInstructions.length > 0 && `${selectedInstructions.length} instruction(s) selected`}
          </div>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-5 py-2 border border-steel-300 text-graphite-700 rounded-full hover:bg-steel-100 transition font-medium"
            >
              Close
            </button>
            <button
              onClick={() => handleDelete(turbine.id)}
              className="px-5 py-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition font-medium"
            >
              Delete
            </button>
            <button
              onClick={() => onEdit(turbine)}
              className="px-5 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition font-medium"
            >
              Edit
            </button>
            <button
              onClick={handleSave}
              className="px-5 py-2 bg-brand-500 text-white rounded-full hover:bg-brand-600 transition font-medium"
            >
              Save Selected Instructions
            </button>
          </div>
        </div>
      </div>
    </div>

  );
  
  
};


export default TurbineDetailsModal;
